import $ from 'jquery';
import includes from 'lodash/includes';
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

import autobind from 'class-autobind';


const isInputableNodeType = (node)=>
  includes(['TEXTREA','INPUT'], node.tagName);


class SearchHotkeyManager extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  componentDidMount() {
    if (this.props.isInPageSearchEnabled) {
      window.addEventListener('keyup', this.handleKeyup, false);
    }
  }

  componentWillUnmount() {
    if (this.props.isInPageSearchEnabled) {
      window.removeEventListener('keyup', this.handleKeyup);
    }
  }

  handleKeyup(e) {
    if (
      (e.which || e.keyCode) === 191 && // pressed forward slash: "/"
      !isInputableNodeType(e.target) // we're not typing in an <input> or <textarea>
    ) {
      this.props.onInPageSearchShow();
    }
  }

  render() {
    return this.props.children;
  }
}

SearchHotkeyManager.propTypes = {
  isInPageSearchEnabled: PropTypes.bool.isRequired,
  onInPageSearchShow: PropTypes.func.isRequired
};


export default SearchHotkeyManager;